import { Grid, TextField, Typography } from "@material-ui/core";
import React from "react";
import { ArrowDropDown } from "@material-ui/icons";
import ReactCountryFlag from "react-country-flag";
import "../style.css";

const NumberInputView = ({
  countryCode,
  dialCode,
  nationalNumber,
  setShowDialCodeView,
  onChangeNationalNumber,
  errors = {},
  displayErrors = false,
}) => {
  return (
    <Grid container direction="column" className="phone-number-input-view">
      <Grid container direction="row" className="column-gap-8">
        <Grid
          item
          xs={4}
          container
          alignItems="center"
          className="country-code-input border-4"
          onClick={() => setShowDialCodeView(true)}
        >
          <Grid
            container
            alignItems="center"
            className="column-gap-8 digit-container"
          >
            <ReactCountryFlag countryCode={countryCode} svg />
            <Typography variant="body2">{dialCode}</Typography>
            <ArrowDropDown />
          </Grid>
        </Grid>
        <Grid item xs>
          <TextField
            type="number"
            name="phoneNumber"
            variant="outlined"
            className={`${
              displayErrors > 0 && errors.phoneNumber && "phone-number-error"
            }`}
            fullWidth
            placeholder="CONTACT NUMBER"
            value={nationalNumber}
            onChange={(e) => onChangeNationalNumber(e.target.value)}
          />
        </Grid>
      </Grid>
      {displayErrors > 0 && errors.phoneNumber && (
        <Typography variant="caption" className="error-txt">
          {errors["phoneNumber"]}
        </Typography>
      )}
    </Grid>
  );
};

export default NumberInputView;
